import * as Types from '../types/BeslenmeType'
import Initials from '../initials/BeslenmeType'

export default function Reducers (state = Initials, action) {
  switch (action.type) {

    case Types.GETALL_SUCCESS:
      return {
        ...state,
        All: action.payload,
        messages: [],
        CustomID: Math.random()
      }

    case Types.GETONE_SUCCESS:
      return {
        ...state,
        One: action.payload,
        messages: [],
        CustomID: Math.random()
      }

    case Types.CREATE_SUCCESS:
      return {
        ...state,
        All: state.All.concat(action.payload),
        messages: [],
        CustomID: Math.random()
      }

    case Types.UPDATE_SUCCESS:
      var updatedAll = state.All.map(aa =>
        aa.beslenmeType_id == action.payload?.beslenmeType_id ? action.payload : aa
      )
      return {
        ...state,
        All: updatedAll,
        messages: [],
        CustomID: Math.random()
      }

    case Types.TOGGLE_SUCCESS:
      var toggledAll = state.All.map(aa =>
        aa.beslenmeType_id == action.payload?.beslenmeType_id ? action.payload : aa
      )
      return {
        ...state,
        All: toggledAll,
        messages: [],
        CustomID: Math.random()
      }

    default:
      return state
  }
}
